import Auth from '@/helpers/authorizations'
import Management from '@/layouts/Management'

export default {
  path: '/point_records',
  component: Management,
  redirect: '/point_records/list',
  children: [
    // 列表页
    {
      path: 'list',
      component: () => import('@/views/point_records/List'),
      redirect: 'list/all',
      meta: {
        auth: Auth.listPointRecords
      },
      children: [
        {
          path: 'all',
          component: () => import('@/views/point_records/ListTable'),
          meta: {
            auth: Auth.listPointRecords,
            tabName: 'all'
          }
        }
      ]
    },
    // 新增
    {
      path: 'new',
      component: () => import('@/views/point_records/New'),
      meta: {
        auth: Auth.createPointRecord
      }
    }
  ]
}
